import { WorkflowPayload } from "generated/graphql";

export type WorkflowPayloadEdit = (payload: WorkflowPayload) => WorkflowPayload;

export interface WorkflowWriteTransport {
    send: (payload: WorkflowPayload) => Promise<void>;
    onSettled: () => void;
}

export interface WorkflowWriteQueue {
    read: () => WorkflowPayload;
    adopt: (upstream: WorkflowPayload) => void;
    edit: (edit: WorkflowPayloadEdit, transport: WorkflowWriteTransport) => Promise<void>;
}

export const createWorkflowWriteQueue = (
    initialPayload: WorkflowPayload,
): WorkflowWriteQueue => {
    let payload = initialPayload;
    let hasUnsentEdits = false;
    let sending: Promise<void> | null = null;

    const sendUntilSettled = async (transport: WorkflowWriteTransport): Promise<void> => {
        while (hasUnsentEdits) {
            hasUnsentEdits = false;
            await transport.send(payload);
        }
    };

    return {
        read: () => payload,
        adopt: (upstream: WorkflowPayload) => {
            if (sending === null && !hasUnsentEdits) {
                payload = upstream;
            }
        },
        edit: (edit: WorkflowPayloadEdit, transport: WorkflowWriteTransport) => {
            payload = edit(payload);
            hasUnsentEdits = true;

            if (!sending) {
                sending = sendUntilSettled(transport).finally(() => {
                    sending = null;
                    transport.onSettled();
                });
            }

            return sending;
        },
    };
};
